import React, { useEffect, useState } from 'react';
import { favoritesAPI } from '../services/api';
import ContentCard from '../components/ContentCard';
import { Heart } from 'lucide-react';

const Favorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      const response = await favoritesAPI.getAll();
      setFavorites(response.data);
    } catch (error) {
      console.error('Error loading favorites:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-electric/30 border-t-electric rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8" data-testid="favorites-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-2">
            <Heart className="h-8 w-8 text-electric fill-electric" />
            <h1 className="text-4xl font-bold text-foreground">My Favorites</h1>
          </div>
          <p className="text-muted-foreground">Your collection of saved content</p>
        </div>

        {/* Favorites Grid */}
        {favorites.length > 0 ? (
          <>
            <div className="mb-6">
              <p className="text-muted-foreground">
                {favorites.length} {favorites.length === 1 ? 'item' : 'items'} in your favorites
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4" data-testid="favorites-grid">
              {favorites.map((item) => (
                <ContentCard key={item.id} content={item} />
              ))}
            </div>
          </>
        ) : (
          <div className="text-center py-20">
            <Heart className="h-20 w-20 text-foreground/20 mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-foreground mb-4">No favorites yet</h2>
            <p className="text-muted-foreground mb-8">Start adding content to your favorites!</p>
            <a
              href="/"
              className="inline-block px-8 py-3 bg-electric text-background rounded-xl font-semibold hover:bg-electric/90 transition-all"
            >
              Browse Content
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;
